import {WaterMarkView} from '@gongxigames/framework/slot/modules/watermark/WaterMarkView';
import {WaterMarkComponentsConfigPortrait} from '@gongxigames/framework/slot/modules/watermark/components/WaterMarkComponentsConfig';
import {StickyRichLabelData} from '@gongxigames/framework/slot/modules/watermark/components/StickyData';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType, ObjectBuilder, ScreenParameters} from '@gongxigames/framework/core';

export class WaterMarkViewMobilePortrait extends WaterMarkView {
    public static readonly NAME: symbol = Symbol('WaterMarkViewMobilePortrait');
    public static layer = LAYERS.WATERMARK;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected GLOBAL_CLOCK_INITIAL_OFFSET = 95;

    protected globalTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.globalTimeClock;
    protected elapsedTimeClockLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.elapsedTimeClock;
    protected sessionBalanceLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.sessionBalance;
    protected globalTimeClockPureData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.globalTimeClock_pure;
    protected gameNameLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.gameName;
    protected sessionBetsLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.sessionBets;
    protected sessionEarningsLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.sessionEarnings;
    protected maxWinProbabilityLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.maxWinProbability;
    protected RTPWatermarkLabelData: StickyRichLabelData = WaterMarkComponentsConfigPortrait.RTPWatermark;

    protected initMainSprite(): void {
        this.imageSprite = this.objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.waterMark_portrait);
        this.container.addChild(this.imageSprite);
    }

    public onResized(screenParams: ScreenParameters): void {
        super.onResized(screenParams);

        this.gameNameLabel?.resize(screenParams, true);
    }

}
